var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"green--text"},[_vm._v(_vm._s(_vm.split2(_vm.title, ' ')[0])),_c('span',{staticClass:"pink--text ml-2"},[_vm._v(_vm._s(_vm.split2(_vm.title, ' ')[1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }